<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
  <div class="col-md-12">
        <div class="card">
          <div class="card-body p-2">
           
            <simplebar>
              <div class="table-responsive">
                <b-table
                  :items="myProvider"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :busy="loading"
                  ref="table"
                  show-empty
                >
                  <template #empty>
                    <div class="d-flex justify-content-center mb-3">
                      No Record Found
                    </div>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-info my-2">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </template>

                  <template #cell(#)="data">
                    {{ data.index + 1 }}
                  </template>

                  <template v-slot:cell(user_name)="data">
                    <router-link :to='"/users/list/"+data.item.user.id' target="_blank" v-if="data.item.user.username">
                      {{ data.item.user.username }}
                    </router-link>
                    <div v-else>-</div>
                  </template>

                  <template v-slot:cell(withdraw_request)="data">
                    <div v-if="data.item.withdraw_request">
                      {{ data.item.withdraw_request }}
                    </div>
                    <div v-else>-</div>
                  </template>

                  <template v-slot:cell(comment)="data">
                    <div v-if="data.item.comment" class="fs-12">
                      {{ data.item.comment }}
                    </div>
                  </template>

                  <template v-slot:cell(currency)="data">
                    <div v-if="data.item.currency">
                      {{ data.item.currency }}
                    </div>
                  </template>

                  


                  <template v-slot:cell(withdraw_request_date)="data">
                    <div v-if="data.item.withdraw_request_date">
                      {{ new Date(data.item.withdraw_request_date).toLocaleDateString() }}
                    </div>
                  </template>

                  <template v-slot:cell(withdraw_release_date)="data">
                    <div v-if="data.item.withdraw_release_date">
                      {{ new Date(data.item.withdraw_release_date).toLocaleDateString() }}
                    </div>
                  </template>

                   <!-- Status section -->
                  <template v-slot:cell(status)="data">
                    <div
                      class="text-center "
                      :class="
                        data.item.status == 1 ? 'bg-success' : 'bg-danger'
                      "
                    >
                      {{ data.item.status == 1 ? "PAID" : "UNPAID" }}
                    </div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <div class="text-capitalize" v-if="new Date(data.item.withdraw_release_date) <= new Date(Date.now()) && data.item.status == 0">
                      <button class="btn btn-primary p-1" @click="paytouser(data.item.id)"> Payout</button>
                    </div>
                    <div v-else>
                       <span class="text-success">Wait...</span> 
                    </div>
                  </template>
                 

                 
                </b-table>
              </div>
             
            </simplebar>
          </div>
        </div>
        <div class="row m-0">
                <div class="col p-0">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import simplebar from "simplebar-vue";
import ApiClass from "../../api/api";
import Swal from "sweetalert2";

export default {
  page: {
    title: "User Stake List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    simplebar,
  },
  data() {
    return {
      title: "User Stake List",
      items: [
        {
          text: "Staking ",
          // href: "/staking/list",
        },
        {
          text: "User Staking List",
          active: true,
        },
      ],
      loading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      sortBy: "value",
      sortDesc: false,
      fields: [
        "#",
        {
          key: "user_name",
          value: "user_name",
          sortable: false,
        },
        {
          key: "withdraw_request",
          value: "Amount",
          sortable: false,
        },
        {
          key: "comment",
          value: "comment",
          sortable: false,
        },
        {
          key: "currency",
          value: "currency",
          sortable: false,
        },
        {
          key: "withdraw_request_date",
          value: "withdraw_request_date",
          sortable: false,
        },
        {
          key: "withdraw_release_date",
          value: "withdraw_release_date",
          sortable: false,
        },
        {
          key: "status",
          value: "status",
          sortable: false,
        },
        {
          key: "action",
          value: "action",
          sortable: false,
        },
        // {
        //     key: "action",
        //     value: "action",
        //     sortable: false,
        // },
      ],
    };
  },
  methods: {
    async myProvider(ctx, callback) {
      this.loading = !this.loading;
      await ApiClass.getNodeRequest("staking/get-withdraw-request-admin", true)
        .then((res) => {
          if (res.data.status_code == 1) {
            this.loading = !this.loading;
            const items = res.data.data ? res.data.data.data : [];
            this.currentPage = res.data.data ? res.data.data.current_page : "";
            this.totalRows = res.data.data ? res.data.data.total : "";
            callback(items);
          }
        })
        .bind(this);
    },
    onclose() {
      this.$root.$emit("bv::hide::modal", "modal-center");
    },
    async paytouser(id){
         Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, Pay it!",
        }).then(async (result) => {
            if (result.value) {
                var response = await ApiClass.postNodeRequest(
                    "staking/portfolio-transfer-by-admin/" + id,
                    true
                );
                this.$refs.table.refresh();
                if(response.data.status_code != 1){
                    Swal.fire("", response.data.message, "error");
                    return;
                }
                Swal.fire("Paid!", response.data.message, "success");
                return;
            }
        });
    }
  },
};
</script>

<style scoped>
.action {
  font-weight: 600;
  cursor: pointer;
}

.add-btn-box {
  text-align: right;
}

.add-btn-box span.addbtn {
  background-color: #556ee6;
  color: #fff;
  padding: 10px 10px;
  border-radius: 5px;
  font-family: "Poppins";
  font-size: 13px;
  font-weight: 400;
}

/* .created_at {
  white-space: nowrap;
} */

.table > :not(caption) > * > * {
  white-space: break-spaces;
}

.form-control {
  border: none;
  border-bottom: 1px solid #ced4da;
  border-right: 1px solid #ced4da;
}

.table th {
  white-space: nowrap;
}
</style>
